/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlignRight2 = createReactComponent("outline", "align-right-2", "IconAlignRight2", [["path", { "d": "M20 4v16", "key": "svg-0" }], ["path", { "d": "M4 6h12", "key": "svg-1" }], ["path", { "d": "M10 12h6", "key": "svg-2" }], ["path", { "d": "M6 18h10", "key": "svg-3" }]]);

export { IconAlignRight2 as default };
//# sourceMappingURL=IconAlignRight2.mjs.map
